import React from "react";

export default function ReviewnApproval(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Oversight, Amendments, Review & Approval
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Slum Soccer/ Krida Vikas Sanstha attaches utmost importance to Child
            Safeguarding and Protection and maintains zero tolerance towards
            child harassment, bullying and abuse.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            For any clarification or explanation in respect of this policy,
            please contact Ms. Mahima B, Head-HR, Slum Soccer at{" "}
            <a
              href="tel:+919359041505"
              className="text-yellow-500 hover:underline"
            >
              +91 9359041505
            </a>{" "}
            Email ID:{" "}
            <a
              href="mailto:mahima.b@slumsoccer.org"
              className="text-yellow-500 hover:underline"
            >
              mahima.b@slumsoccer.org
            </a>
            . Head-HR shall also be responsible for organizing of trainings/
            refresher courses on the subject as well as dissemination of this
            policy to all stakeholders.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            CEO, Slum Soccer shall oversee the implementation of the policy and
            its monitoring and evaluation.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            This Policy (Version 5), has been approved by the CEO of Slum Soccer
            Dr. Abhijeet Barse and is effective from 01st March, 2025.Any
            amendment to this policy can be made with the approval of CEO, Slum
            Soccer only.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            This Policy (Version 5) would be reviewed periodically but not later
            than two years from the date of effect of this version of the
            policy.
          </span>
        </div>
      </div>
    </div>
  );
}
